import React from "react";
import QuestionRenderer from "./QuestionRenderer";

function QuestionScreen({
  question,
  questions,
  questionIndex,
  totalQuestions,
  pageTitle,
  pageDescription,
  answers,
  onAnswerChange,
  onBack,
  onContinue,
  canContinue,
  showBack = true,
}) {
  const progress = ((questionIndex + 1) / totalQuestions) * 100;
  const pageQuestions = questions?.length ? questions : question ? [question] : [];
  // const screenTitle =
  //   pageTitle ||
  //   pageQuestions[0]?.pageTitle ||
  //   "Tell us about your home";
  const screenSubtitle =
    pageDescription ||
    pageQuestions[0]?.pageDescription ||
    pageQuestions[0]?.description;

  return (
    <div className="req-screen req-screen-question">
      <div className="req-content">
        <div className={`req-inline-header${showBack ? "" : " req-inline-header-no-back"}`}>
          {showBack ? (
            <button
              type="button"
              className="req-back-icon-btn"
              onClick={onBack}
              aria-label="Go back"
            >
              <img src="/caretLeft.svg" alt="" />
            </button>
          ) : null}
          <p className="req-eyebrow">Post your requirement</p>
        </div>

        {/* <h1 className="req-title">{screenTitle}</h1>
        {screenSubtitle ? (
          <p className="req-subtitle">{screenSubtitle}</p>
        ) : null} */}

        <div className="req-question-page-fields">
          {pageQuestions.map((item) => (
            <div
              className="req-question-field"
              key={item.id}
              id={`req-question-field-${item.id}`}
            >
              {!item.hideFieldLabel ? (
                <div className="req-question-label-wrap">
                  <div className="req-question-label">
                    {item.label} {item.required && <span>*</span>}
                  </div>
                  {item.helpText ? (
                    <p className="req-question-helptext">{item.helpText}</p>
                  ) : null}
                </div>
              ) : null}
              <QuestionRenderer
                question={item}
                value={answers[item.id]}
                onChange={(value) => onAnswerChange(item.id, value)}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="req-footer">
        <div className="req-progress-track">
          <div
            className="req-progress-fill"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div
          className={`req-footer-actions req-footer-actions-select${
            showBack ? "" : " req-footer-actions-single"
          }`}
        >
          {showBack ? (
            <button type="button" className="req-secondary-btn" onClick={onBack}>
              Go back
            </button>
          ) : null}
          <button
            type="button"
            className="req-primary-btn"
            onClick={onContinue}
            disabled={!canContinue}
          >
            {questionIndex === totalQuestions - 1 ? "Review" : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default QuestionScreen;
